import React from 'react';
import { Player, ControlBar, PlayToggle, VolumeMenuButton, BigPlayButton } from 'video-react';

export default props => {
  return (
    <>
    <div class="video-screen">
    <Player 
      fluid
      playsInline
      // autoPlay
      muted
      loop
      src="/new_reel_23.mp4">
      <BigPlayButton position="center" className="bigplay"/>
      <ControlBar disableCompletely={false} className="vidbar" >
      {/* <PlayToggle /> */}
      <VolumeMenuButton disabled />
      </ControlBar>
      </Player>
    </div>
    </>
  );
};


// import React from 'react';
// import { Player, ControlBar } from 'video-react';

// export default props => {
//   return (
//     <Player
//     fluid
//     // className='w-100 h-100'
//     autoPlay
//     muted
//     playsInline
//     // data-autoplay=""
//     poster="/assets/poster.png"
//     src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
//  >     
//   <ControlBar autoHide={true} /> 
//  </Player>
//   );
// };

// import * as THREE from 'three'
// import { useEffect, useState } from 'react'
// import { Canvas, useThree } from '@react-three/fiber'
// import MediaQuery from 'react-responsive'
// import { useAspect } from '@react-three/drei'

// function Scene() {
//   const viewport = useThree(state => state.viewport)
//     const [video] = useState(() =>
//     Object.assign(document.createElement('video'), { src: '/test_reel_24.mp4', crossOrigin: 'Anonymous', loop: true, muted: true, playsinline: true,  autoplay: true
//   }),
//   )
//     useEffect(() => void video.play(), [video])
//     useEffect(() => {
//       setTimeout(() => {
//         video.play();
//       }, 100);
//     }, [video])
    
//   return (
//     <>
//     <MediaQuery maxWidth={800}>
//     <mesh scale={[920, viewport.height - 220, 2]}>    
//       <planeGeometry />
//       <meshBasicMaterial toneMapped={false}>
//         <videoTexture attach="map" args={[video]} encoding={THREE.sRGBEncoding} />
//       </meshBasicMaterial>
//     </mesh>
//     </MediaQuery>
//            <MediaQuery minWidth={801} maxWidth={1823}>
//               <mesh scale={[1920, 1080, 1]}>    
//       <planeGeometry />
//       <meshBasicMaterial toneMapped={false}>
//         <videoTexture attach="map" args={[video]} encoding={THREE.sRGBEncoding} />
//       </meshBasicMaterial>
//     </mesh>
//     </MediaQuery>
//     </>

//   )
// }

// export default function App() {
//   return (
//     <Canvas orthographic>
//       <Scene />
//     </Canvas>
//   )
// }
